import {
  UserOutlined,
 ShoppingOutlined,
  CloseCircleOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { PageHeader, Popconfirm, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  dineroDisabledMask,
  TableItemDinamico,
  ButtonItem,
} from "../../../Components/Items";
import SelectProveedoresItem from "../../../Components/SelectProveedoresItem";
import SelectInsumosItem from "../../../Components/SelectInsumosItem";
import ModalEditarRelacion from "./ModalEditarRelacion/ModalEditarRelacion";
import AyudaConversion from "../../../Components/AyudaConversion";
class InsumoProveedor extends Component {
  tableRef = null;
  state = {
    todasRelaciones: [],
    loading: false,
    valor: 3,
    totalRecords: 0,
    textoFiltro: "",
    proveedorId: null,
    insumoId: null,
    modalEditarVisible: false,
    recordActual: null,
  };

  proveedorIdKey = "insumoProveedor_proveedorId";
  insumoIdKey = "insumoProveedor_insumoId";

  componentDidMount() {
    const storedProveedorId = sessionStorage.getItem(this.proveedorIdKey);
    const storedInsumoId = sessionStorage.getItem(this.insumoIdKey);

    if (storedProveedorId) {
      this.setState({ proveedorId: storedProveedorId, insumoId: null }, () => {
        if (this.tableRef) this.tableRef.fetchData();
      });
    } else if (storedInsumoId) {
      this.setState({ insumoId: storedInsumoId, proveedorId: null }, () => {
        if (this.tableRef) this.tableRef.fetchData();
      });
    }
  }
  consultarRelaciones(params) {
    const { proveedorId, insumoId } = this.state;
    if (!proveedorId && !insumoId) {
      this.setState({
        loading: false,
        todasRelaciones: [],
        totalRecords: 0,
        modalEditarVisible: false,
        recordActual: null,
      });
      return;
    }

    this.setState({ loading: true });

    const {page = 1, pageSize = 10, ...otrosParams} = params;
    const limit = pageSize; 
    const skip = (page-1) * pageSize; 
    const body = {
      empresaId: this.props.empresaId,
      limit: limit, 
      skip: skip,
      ...otrosParams,
      proveedorId: this.state.proveedorId,
      insumoId: this.state.insumoId,
    };
    axios
      .post("insumos/obtenerRelacionesInsumoProveedor", body, {
        headers: this.props.headersToken,
      })
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            todasRelaciones: res.data.data,
            totalRecords: res.data.totalRecords || 0,
            loading: false,
          });
        } else {
          this.setState({
            todasRelaciones: [],
            totalRecords: 0,
            loading: false,
          });
        }
      })
      .catch((err) => {
        console.error("Error al consultar relaciones:", err);
        this.setState({ todasRelaciones: [], totalRecords: 0, loading: false });
      });
  }

  onChangeProveedor = (proveedorId) => {
    if (proveedorId) {
      sessionStorage.setItem(this.proveedorIdKey, proveedorId);
      sessionStorage.removeItem(this.insumoIdKey);
    } else {
      sessionStorage.removeItem(this.proveedorIdKey);
    }
    this.setState({ proveedorId: proveedorId, insumoId: null }, () => {
      if (this.tableRef) {
        this.tableRef.fetchData();
      }
    });
  };

  onChangeInsumo = (insumoId) => {
    if (insumoId) {
      sessionStorage.setItem(this.insumoIdKey, insumoId);
      sessionStorage.removeItem(this.proveedorIdKey);
    } else {
      sessionStorage.removeItem(this.insumoIdKey);
    }
    this.setState({ insumoId: insumoId, proveedorId: null }, () => {
      if (this.tableRef) {
        this.tableRef.fetchData();
      }
    });
  };

  verInsumo(id) {
    this.props.history.push("/panel/editarInsumo", { id });
  }

  verProveedor(id) {
    this.props.history.push("/panel/editarProveedor", { id });
  }
  eliminarRelacion = (record) => {
    // Ponemos la tabla en loading
    this.setState({ loading: true });
    const { insumoId, _id } = record; // _id es el relacionId

    axios
      .post(
        "insumos/cancelarRelacionInsumo",
        { insumoId, relacionId: _id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        message.success("Relación cancelada exitosamente");
        // Recargamos la data de la tabla
        if (this.tableRef) {
          this.tableRef.fetchData();
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        console.error("Error al cancelar la relación:", err);
        message.error("Error al cancelar la relación");
        this.setState({ loading: false });
      });
  };

  abrirModalEditar = (record) => {
    this.setState({
      modalEditarVisible: true,
      recordActual: record._id,
    });
  };

  cerrarModalEditar = () => {
    this.setState({
      modalEditarVisible: false,
      recordActual: null,
    });
  };

  handleEdicionSuccess = () => {
    this.setState({
      modalEditarVisible: false,
      recordActual: null,
    });

    if (this.tableRef) {
      this.tableRef.fetchData();
    }
  };

  render() {
    const columns = [
      {
        title: "Clave",
        dataIndex: "clave",
        key: "clave",
        defaultSortOrder: "ascend",
        sorter: (a, b) => {
          if (a.clave < b.clave) {
            return -1;
          }
          if (a.clave > b.clave) {
            return 1;
          }
          return 0;
        },
        buscar: "clave",
        width: "5%",
      },
      {
        title: "Código Proveedor",
        dataIndex: "codigoProveedor",
        key: "codigoProveedor",
        buscar: "codigo",
        width: "8%",
      },
      {
        title: "Proveedor",
        dataIndex: "proveedor",
        key: "descripcion",
        sorter: true,
        buscar: "proveedor",
        width: "15%",
      },
      {
        title: "Descripción Insumo",
        dataIndex: "descripcionInsumo",
        key: "insumo",
        defaultSortOrder: "ascend",
        sorter: true,
        buscar: "clave",
        width: "15%",
      },
      {
        title: "Descripción Proveedor",
        dataIndex: "descripcionProveedor",
        key: "descripcion",
        defaultSortOrder: "ascend",
        sorter: true,
        buscar: "clave",
        width: "15%",
      },
      {
        title: "Unidad",
        dataIndex: "unidad",
        key: "unidad",
        align: "center",
        width: "6%",
      },
      {
        title: "Conversión",
        dataIndex: "conversion",
        key: "conversion",
        sorter: true,
        width: "6%",
        render: (conversion, record) => (
          <span>
            {conversion}
            <AyudaConversion insumo={{ _id: record._id, conversion }} />
          </span>
        ),
      },
      {
        title: "Compra Min",
        dataIndex: "compraMin",
        key: "compraMin",
        align: "center",

        width: "6%",
      },
      {
        title: "Costo / Costo Unitario",
        dataIndex: "costo",
        key: "costo",
        sorter: true,
        render: (_, record) => (
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: "12px", color: "#666" }}>
              {dineroDisabledMask(record.costo)}
            </div>
            <div style={{ fontSize: "12px", fontWeight: "bold" }}>
              {dineroDisabledMask(record.costoUnitario)}
            </div>
          </div>
        ),
        width: "10%",
        align: "right",
      },
      {
        title: "Costo Unitario",
        dataIndex: "costoUnitario",
        key: "costoUnitario",
        buscar: "costoUnitario",
        responsive: [],
        width: 0,
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: "15%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value, record) => {
          let buttons = [];

          buttons.push(
            <Tooltip title="Ver Insumo" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`insumo-${record._id}`}
                type="default"
                size="small"
                blanco
                icon={<ShoppingOutlined />}
                onClick={() => this.verInsumo(record.insumoId)}
              >
              </ButtonItem>
            </Tooltip>
          );

          buttons.push(
            <Tooltip title="Ver Proveedor" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`proveedor-${record._id}`}
                type="default"
                size="small"
                lima
                icon={<UserOutlined />}
                onClick={() => this.verProveedor(record.proveedorId)}
              >
              </ButtonItem>
            </Tooltip>
          );

          buttons.push(
            <Tooltip title="Editar Relación" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`editar-${record._id}`}
                type="default"
                size="small"
                cyan
                icon={<EditOutlined />}
                onClick={() => this.abrirModalEditar(record)}
              >
              </ButtonItem>
            </Tooltip>
          );

          buttons.push(
            <Popconfirm
              key={`eliminar-${record._id}`}
              title="¿Seguro que quiere eliminar esta relación del insumo?"
              onConfirm={() => this.eliminarRelacion(record)}
              okText="Ok"
              cancelText="Cancelar"
            >
              <Tooltip title="Eliminar Relación" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  type="default"
                  size="small"
                  rojo
                  icon={<CloseCircleOutlined />}
                >
                </ButtonItem>
              </Tooltip>
            </Popconfirm>
          );

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];

    const {
      proveedorId,
      insumoId,
      loading,
      totalRecords,
      todasRelaciones,
      modalEditarVisible,
      recordActual,
    } = this.state;
    let customEmptyText = "No se encontraron relaciones.";

    if (!proveedorId && !insumoId) {
      customEmptyText =
        "Selecciona un proveedor o un insumo para ver las relaciones.";
    }

    const filteredColumns = columns.filter((col) => {
      // Si estamos en modo Proveedor
      // ocultamos la columna 'proveedor'.
      if (proveedorId && col.dataIndex === "proveedor") {
        return false;
      }

      // Si estamos en modo Insumo
      // ocultamos la columna 'descripcionInsumo'
      if (insumoId && col.dataIndex === "descripcionInsumo") {
        return false;
      }

      // Para todas las demás columnas, las mostramos.
      return true;
    });
    return (
      <>
        <PageHeader
          title="Relación Insumo Proveedor"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
              <SelectProveedoresItem
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
                value={this.state.proveedorId}
                placeholder={"Selecciona un proveedor"}
                onChange={this.onChangeProveedor}
                style={{ width: "300px" }}
              />
              <SelectInsumosItem
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
                value={this.state.insumoId}
                onChange={this.onChangeInsumo}
                placeholder={"Selecciona un insumo"}
                tiposInsumos="generales"
                style={{ width: "300px" }}
              />
            </>
          }
        />
        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={totalRecords}
          loading={loading}
          anadirValorFiltro={this.state.valor}
          onFetchData={this.consultarRelaciones.bind(this)}
          size="small"
          dataSource={todasRelaciones}
          columns={filteredColumns}
          pagination={false}
          /*onRow={(record) => ({
            onDoubleClick: () => this.verProveedor(record._id),
          })}*/
          setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })}
          filterStorageKey={
            "insumoProveedorFiltrosTabla" + this.props.empresaId
          }
          setValor={(valor) => this.setState({ valor })}
          valorDefault={3}
          valorTextoDefault={""}
          locale={{ emptyText: customEmptyText }}
        />
        {recordActual && (
          <ModalEditarRelacion
            visible={modalEditarVisible}
            relacionId={recordActual}
            onCancel={this.cerrarModalEditar}
            onSuccess={this.handleEdicionSuccess}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(InsumoProveedor);
